import BaseValidator from '@/lib/data/validator/BaseValidator'

export default class SynthesisSupportInputValidator extends BaseValidator {
  validatorRules = {
    email: {
      required: false,
      type    : BaseValidator.Type.Email
    },
    contactNumber: {
      required  : false,
      type      : BaseValidator.Type.String,
      betweenLen: [10, 14]
    },
    subject: {
      required: true,
      type    : BaseValidator.Type.String,
      minLen  : 3
    },
    message: {
      required: true,
      type    : BaseValidator.Type.String,
      minLen  : 10
    }
  }

  validatorMessages = {
    el: {},
    en: {}
  }

  constructor (data = {}) {
    super(data)
  }
}
